import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Scrolltotop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top whenever the pathname changes
  }, [pathname]);

  return null; // No UI for this component
};

export default Scrolltotop;
